import {useEffect} from "react";

/*We added an event dispatch in fetchWrapper
Whenever fetchwrapper succeeds in browser, it dispatches an event "renew"
That is because a successful fetch wrapper operation should also result in an updated
timeout window for our SSO session.

We can listen to that event and keep our own counter for our modal updated.
*/
const defaultFunc = () => {};
const useGlobalRenewEvent = ({onRenew = defaultFunc}) => {
  useEffect(() => {

    window.addEventListener("renew",onRenew);

    return () => {
      window.removeEventListener("renew",onRenew);
    }
  },[onRenew]);

}

export default useGlobalRenewEvent;